module.exports = __webpack_public_path__ + "static/img/p6_1.c539019.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/p6_1.png
// module id = ApP5
// module chunks = 0